export default {
  "content": "<g clip-path=\"url(#clip0_379_6896)\" stroke=\"#F8FBFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.357 9.899L5.186 7.07 8.014 9.9M20.27 12.729l-2.829 2.828-2.828-2.828\"/><path d=\"M8.725 5.897a6 6 0 018.584 5.417l.132 4.242M5.185 7.071l.132 4.243A6 6 0 0013.9 16.73\"/></g><defs><clipPath id=\"clip0_379_6896\"><path fill=\"#fff\" transform=\"rotate(45 5.657 13.657)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "23",
    "height": "23",
    "viewBox": "0 0 23 23",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};